export default __webpack_public_path__ + "static/media/Karcher-Banner.1d7f3849.jpg";